import { useContext } from "react";
import {
  RateCalculatorDispatchContext,
  RateCalculatorStateContext,
} from "./rate-calculator-context";

export function useRateCalculatorState() {
  const context = useContext(RateCalculatorStateContext);
  if (context === undefined) {
    throw new Error(
      "useRateCalculatorState must be used within a RateCalculatorProvider",
    );
  }
  return context;
}

export function useRateCalculatorDispatch() {
  const context = useContext(RateCalculatorDispatchContext);
  if (context === undefined) {
    throw new Error(
      "useRateCalculatorDispatch must be used within a RateCalculatorProvider",
    );
  }
  return context;
}

export function useRateCalculator() {
  return {
    state: useRateCalculatorState(),
    dispatch: useRateCalculatorDispatch(),
  };
}
